import React from "react"
import Style from "@/components/GlobalVisualSearch/LoadingSpinner/index.module.scss"
import { Spinner } from "@kohler-dsm-library/kohler-core"

const LoadingSpinner = () => {
  return (
    <div className={Style.LoadingSpinnerContainer}>
      <div className="loading-spinner-section">
        <Spinner />
      </div>
    </div>
  )
}

export default LoadingSpinner
